const colors = {
    primary: "#CB002B",
    secondary: "#A0616A",
    text: "#44494D",
    font: "Roboto",
    border: "#E0E0E0"
};

export default colors;
